import { render, staticRenderFns } from "./MotivoNaoVenda.vue?vue&type=template&id=67004600"
import script from "./MotivoNaoVenda.vue?vue&type=script&lang=js"
export * from "./MotivoNaoVenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports